var $5421edafdede5c5e$exports = {};
$5421edafdede5c5e$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Kleurkiezer`,
    "colorSwatch": `kleurstaal`,
    "transparent": `transparant`,
    "twoDimensionalSlider": `2D-schuifregelaar`
};


export {$5421edafdede5c5e$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
